import { Alert, Button, Intent, Menu, MenuItem, Popover, Position } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import { AllotmentDetailPageFragment, useDeleteAllotmentMutation } from '../../../generated/graphql';
import { showErrorMessage } from '../../../helpers/graphql';

type AllotmentDetailMenuProps = {
  allotment: AllotmentDetailPageFragment;
  onEdit: () => void;
};

const AllotmentDetailMenu = ({ allotment, onEdit }: AllotmentDetailMenuProps) => {
  const history = useHistory();
  const [isForceDeleteAlertOpen, setIsForceDeleteAlertOpen] = useState(false);

  const [deleteAllotment, { loading: deleting }] = useDeleteAllotmentMutation({
    variables: {
      id: allotment.id,
    },
    onCompleted: () => {
      AppToaster.success(`${allotment.name}  wurde entfernt`);
      history.goBack();
    },
    onError: showErrorMessage,
  });

  return (
    <>
      <Alert
        isOpen={isForceDeleteAlertOpen}
        cancelButtonText="Abbrechen"
        confirmButtonText="Entfernen"
        icon={IconNames.DELETE}
        intent={Intent.DANGER}
        onClose={() => setIsForceDeleteAlertOpen(false)}
        onConfirm={deleteAllotment as any}
      >
        <p>Soll dieses Kontingent wirklich undwiderruflich entfernt werden?</p>
      </Alert>
      <Button text="Bearbeiten" icon={IconNames.EDIT} className="ml-2" onClick={onEdit} />
      <Popover
        position={Position.BOTTOM}
        content={
          <Menu>
            <MenuItem
              text="Entfernen"
              icon={IconNames.DELETE}
              intent={Intent.DANGER}
              onClick={() => setIsForceDeleteAlertOpen(true)}
            />
          </Menu>
        }
      >
        <Button icon={IconNames.MORE} className="ml-2" loading={deleting} />
      </Popover>
    </>
  );
};

export default AllotmentDetailMenu;
